import { CSP_ROLES, GC_ROLES } from '@/utilities/constants';
import { checkIndicator, isArrayContainingSome } from '@/utilities/utilities';
import { LocalStorageService } from 'br2s-ui-common-utils-02';
import { Typography } from 'br2s-ui-componentlibrary_r2_02';
import classNames from 'classnames';
import { useEffect, useState } from 'react';

type ProfileIndicatorProps = {
  indicators: {
    cspIndicator?: string;
    gcIndicator?: string;
    ipIndicator?: string;
    orIndicator?: string;
  };
  roles?: any;
};

const ProfileIndicator = ({ indicators, roles }: ProfileIndicatorProps) => {
  const [profile, setProfile] = useState<string>('');
  const [profileBgIdentifier, setProfileBgIdentifier] = useState<string>('');
  const { uenName } = LocalStorageService.getAuthInfo('uenName');
  useEffect(() => {
    const determineProfile = (): string => {
      if (!checkIndicator()) return 'position holder';
      if (
        (indicators.cspIndicator === 'Y' || indicators.gcIndicator === 'Y') &&
        isArrayContainingSome(roles, GC_ROLES)
      )
        return 'Group of Companies';
      if (
        indicators.cspIndicator === 'Y' &&
        isArrayContainingSome(roles, CSP_ROLES)
      )
        return 'Corporate Service Provider';
      if (indicators.orIndicator === 'Y') return 'Official Receiver';
      if (indicators.ipIndicator === 'Y') return 'Insolvency Practitioner';
      return '';
    };

    const resolvedProfile = determineProfile();
    setProfile(resolvedProfile);
    setProfileBgIdentifier(resolvedProfile.replace(/\s+/g, '-')); //this state will be use as className to handle banner bg color
  }, [indicators, roles]);

  let labelAppend = 'as a'
  if(profile === 'Official Receiver' || profile === 'Insolvency Practitioner') {
    labelAppend = 'as an'
  } else if(profile === 'Group of Companies') {
    labelAppend = 'under'
  }

  const baseIndicatorText = `You are logged in ${labelAppend} ${profile}`;
  const isGroup = profile === 'Group of Companies' ? 'for' : 'of'
  const label = uenName
    ? `${baseIndicatorText} ${isGroup} ${uenName}`
    : baseIndicatorText;

  return (
    <div
      className={classNames('profile-indicator', {
        [profileBgIdentifier]: true,
      })}
    >
      <div className="container">
        <div className="profile-indicator-label">
          {profile && <Typography label={label} type="subheadline" />}
        </div>
      </div>
    </div>
  );
};

export default ProfileIndicator;
